// extracted by mini-css-extract-plugin
module.exports = {"nominations":"styles-module--nominations--3H15M","awards":"styles-module--awards--j8yqw","nominations__item":"styles-module--nominations__item--1xdN_"};